import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'


export default {

    async [actionTypes.PAGAMENTO.CADASTRAR_PAGAMENTO](context, dados) {
        const {data} = await api.pagamento.cadastrar(dados)
        return data
    },

    async [actionTypes.PAGAMENTO.EDITAR_PAGAMENTO](context, dados) {
        const {data} = await api.pagamento.editar(dados)
        return data
    },

    async [actionTypes.PAGAMENTO.BUSCAR_PAGAMENTOS_POR_COBRANCA_ID](context, id) {
        const {data} = await api.pagamento.buscarPorCobrancaId(id)
        return data
    },

    async [actionTypes.PAGAMENTO.EXCLUIR_PAGAMENTO](context, id) {
        await api.pagamento.excluir(id)
    },
}